import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const WhyChooseUsSection = () => {
  const { language } = useLanguage();

  const reasons = [
    {
      id: 'expertise',
      title: {
        fr: 'Expertise technique spécialisée',
        ar: 'خبرة فنية متخصصة',
        en: 'Specialized Technical Expertise'
      },
      description: {
        fr: 'Notre équipe possède une connaissance approfondie des systèmes d\'instrumentation Panametrics et plus de 20 ans d\'expérience combinée dans le secteur Pétrole, Gaz et Industrie.',
        ar: 'يمتلك فريقنا معرفة عميقة بأنظمة قياس Panametrics وأكثر من 20 عامًا من الخبرة المشتركة في قطاع النفط والغاز والصناعة.',
        en: 'Our team possesses deep knowledge of Panametrics instrumentation systems and over 20 years of combined experience in the Oil, Gas and Industry sector.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      id: 'certified',
      title: {
              fr: 'Équipe certifiée',
      ar: 'فريق معتمد',
      en: 'Certified Team'
      },
      description: {
              fr: 'Notre certification garantit que nous respectons les normes les plus strictes en matière de sécurité, de santé et d\'environnement dans toutes nos opérations.',
      ar: 'تضمن شهادتنا أننا نلتزم بأعلى المعايير في مجال السلامة والصحة والبيئة في جميع عملياتنا.',
      en: 'Our certification ensures that we adhere to the strictest standards for safety, health, and environment in all our operations.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      id: 'support',
      title: {
        fr: 'Support technique 24/7',
        ar: 'دعم فني على مدار الساعة',
        en: '24/7 Technical Support'
      },
      description: {
        fr: 'Notre équipe d\'assistance technique est disponible 24 heures sur 24, 7 jours sur 7, pour garantir que vos systèmes d\'instrumentation fonctionnent toujours de manière optimale.',
        ar: 'فريق الدعم الفني لدينا متاح على مدار 24 ساعة طوال أيام الأسبوع، لضمان عمل أنظمة القياس الخاصة بك بشكل مثالي دائمًا.',
        en: 'Our technical support team is available 24/7 to ensure your instrumentation systems are always operating optimally.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
        </svg>
      )
    },
    {
      id: 'solutions',
      title: {
        fr: 'Solutions sur mesure',
        ar: 'حلول مخصصة',
        en: 'Tailored Solutions'
      },
      description: {
        fr: 'Nous adaptons nos solutions d\'instrumentation aux besoins spécifiques de votre installation Pétrole, Gaz et Industrie, garantissant une performance et une efficacité optimales.',
        ar: 'نقوم بتكييف حلول القياس لدينا وفقًا للاحتياجات المحددة لمنشأتك في قطاع النفط والغاز والصناعة، مما يضمن الأداء والكفاءة المثلى.',
        en: 'We tailor our instrumentation solutions to the specific needs of your Oil, Gas and Industry facility, ensuring optimal performance and efficiency.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      id: 'quality',
      title: {
        fr: 'Qualité garantie',
        ar: 'جودة مضمونة',
        en: 'Guaranteed Quality'
      },
      description: {
        fr: 'Nous ne travaillons qu\'avec des produits Panametrics de la plus haute qualité et suivons des protocoles rigoureux pour garantir l\'excellence dans tous nos services.',
        ar: 'نحن نعمل فقط مع منتجات Panametrics ذات الجودة العالية ونتبع بروتوكولات صارمة لضمان التميز في جميع خدماتنا.',
        en: 'We work only with the highest quality Panametrics products and follow rigorous protocols to ensure excellence in all our services.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      )
    },
    {
      id: 'training',
      title: {
        fr: 'Formation complète',
        ar: 'تدريب شامل',
        en: 'Comprehensive Training'
      },
      description: {
        fr: 'Nous offrons des programmes de formation complets pour votre équipe, garantissant qu\'ils peuvent exploiter et maintenir efficacement vos systèmes d\'instrumentation.',
        ar: 'نقدم برامج تدريبية شاملة لفريقك، مما يضمن قدرتهم على تشغيل وصيانة أنظمة القياس الخاصة بك بكفاءة.',
        en: 'We offer comprehensive training programs for your team, ensuring they can effectively operate and maintain your instrumentation systems.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path d="M12 14l9-5-9-5-9 5 9 5z" />
          <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 14l9-5-9-5-9 5 9 5z" />
        </svg>
      )
    }
  ];

  const getLanguageText = (textObj) => {
    return textObj[language] || textObj.fr || textObj.en;
  };

  return (
    <section className="section section-dark" style={{ 
      position: 'relative',
      padding: '6rem 0',
      overflow: 'hidden',
      backgroundColor: '#1a1a1a',
      backgroundImage: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '5%',
        left: '0',
        width: '400px',
        height: '400px',
        borderRadius: '43% 57% 70% 30% / 30% 36% 64% 70%',
        background: 'linear-gradient(45deg, rgba(255, 107, 0, 0.03) 0%, rgba(255, 215, 0, 0.03) 100%)',
        animation: 'blob-animation 25s linear infinite',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '5%',
        right: '0',
        width: '350px',
        height: '350px',
        borderRadius: '70% 30% 30% 70% / 60% 40% 60% 40%',
        background: 'linear-gradient(45deg, rgba(255, 107, 0, 0.03) 0%, rgba(255, 215, 0, 0.03) 100%)',
        animation: 'blob-animation-reverse 20s linear infinite',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ 
        position: 'relative', 
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        {/* Section header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.5rem 1.5rem',
            backgroundColor: 'rgba(255, 107, 0, 0.1)',
            color: 'var(--assco-orange)',
            borderRadius: '30px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            {language === 'fr' ? 'POURQUOI NOUS CHOISIR' : 
             language === 'ar' ? 'لماذا تختارنا' : 
             'WHY CHOOSE US'}
          </span>

          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: 'white',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Notre engagement envers l\'excellence' : 
             language === 'ar' ? 'التزامنا بالتميز' : 
             'Our Commitment to Excellence'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: 'rgba(255, 255, 255, 0.8)',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Découvrez ce qui fait d\'ASSCO le partenaire de confiance pour les solutions d\'instrumentation Pétrole, Gaz et Industrie en Algérie.' 
              : language === 'ar'
              ? 'اكتشف ما يجعل ASSCO الشريك الموثوق به لحلول القياس في قطاع النفط والغاز والصناعة في الجزائر.'
              : 'Discover what makes ASSCO the trusted partner for Oil, Gas and Industry instrumentation solutions in Algeria.'}
          </p>
        </div>
        
        {/* Reasons grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: '2rem'
        }}>
          {reasons.map((reason, index) => (
            <div 
              key={reason.id}
              className="reason-card fade-in"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                transition: 'all 0.3s ease',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                animationDelay: `${0.1 * index}s`
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                e.currentTarget.style.borderColor = 'var(--assco-orange)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
              }}
            >
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                display: 'flex',
                alignItems: 'center',
                gap: '1.5rem',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '16px',
                  backgroundColor: 'rgba(255, 107, 0, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--assco-orange)',
                  flexShrink: 0
                }}>
                  <div style={{ width: '32px', height: '32px' }}>
                    {reason.icon}
                  </div>
                </div>
                
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: 'white',
                  margin: 0
                }}>
                  {getLanguageText(reason.title)}
                </h3>
              </div>
              
              <div style={{
                padding: '2rem',
                flex: 1,
                display: 'flex',
                flexDirection: 'column'
              }}>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.7',
                  color: 'rgba(255, 255, 255, 0.8)',
                  margin: 0,
                  flex: 1
                }}>
                  {getLanguageText(reason.description)}
                </p>
                
                <div style={{
                  marginTop: '2rem',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <button
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      backgroundColor: 'transparent',
                      color: 'var(--assco-orange)',
                      border: 'none',
                      padding: '0.5rem',
                      borderRadius: '0.375rem',
                      fontWeight: '600',
                      fontSize: '0.875rem',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 107, 0, 0.1)';
                      e.currentTarget.style.gap = '0.75rem';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.gap = '0.5rem';
                    }}
                  >
                    {language === 'fr' ? 'En savoir plus' : 
                     language === 'ar' ? 'معرفة المزيد' : 
                     'Learn more'}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Trust banner */}
        <div style={{
          marginTop: '5rem',
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
          borderRadius: '24px',
          padding: '3rem',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
          backgroundImage: 'linear-gradient(135deg, rgba(26, 26, 26, 0.8) 0%, rgba(42, 42, 42, 0.9) 100%)',
          position: 'relative',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.15)'
        }}>
          {/* Decorative circles */}
          <div style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0) 70%)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '-30px',
            left: '-30px',
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0) 70%)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'relative',
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '24px',
              backgroundColor: 'var(--assco-orange)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem',
              transform: 'rotate(-5deg)',
              boxShadow: '0 10px 15px rgba(255, 107, 0, 0.3)'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="white">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            
            <h3 style={{
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '1rem',
              color: 'white'
            }}>
              {language === 'fr' ? 'Votre partenaire de confiance en instrumentation' : 
               language === 'ar' ? 'شريكك الموثوق في مجال القياس' : 
               'Your Trusted Instrumentation Partner'}
            </h3>
            
            <div style={{
              width: '60px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px',
              marginBottom: '2rem'
            }}></div>
            
            <p style={{
              fontSize: '1.25rem',
              lineHeight: '1.8',
              color: 'rgba(255, 255, 255, 0.8)',
              maxWidth: '800px',
              marginBottom: '2.5rem'
            }}>
              {language === 'fr' 
                ? 'Depuis notre création, nous nous sommes engagés à fournir des solutions d\'instrumentation Pétrole, Gaz et Industrie de la plus haute qualité, soutenues par une expertise technique inégalée et un service client exceptionnel.' 
                : language === 'ar'
                ? 'منذ تأسيسنا، التزمنا بتقديم حلول قياس عالية الجودة في قطاع النفط والغاز والصناعة، مدعومة بخبرة فنية لا مثيل لها وخدمة عملاء استثنائية.'
                : 'Since our inception, we have been committed to providing the highest quality Oil, Gas and Industry instrumentation solutions, backed by unmatched technical expertise and exceptional customer service.'}
            </p>
            
            <div style={{
              display: 'flex',
              gap: '1.5rem',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '1.5rem',
                borderRadius: '16px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                minWidth: '180px'
              }}>
                <div style={{ fontSize: '2.5rem', fontWeight: '800', color: 'var(--assco-orange)' }}>50+</div>
                <div style={{ fontWeight: '600', color: 'rgba(255, 255, 255, 0.8)' }}>
                  {language === 'fr' ? 'Projets réalisés' : 
                   language === 'ar' ? 'المشاريع المنجزة' : 
                   'Projects completed'}
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '1.5rem',
                borderRadius: '16px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                minWidth: '180px'
              }}>
                <div style={{ fontSize: '2.5rem', fontWeight: '800', color: 'var(--assco-orange)' }}>100%</div>
                <div style={{ fontWeight: '600', color: 'rgba(255, 255, 255, 0.8)' }}>
                  {language === 'fr' ? 'Satisfaction client' : 
                   language === 'ar' ? 'رضا العملاء' : 
                   'Customer satisfaction'}
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '1.5rem',
                borderRadius: '16px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                minWidth: '180px'
              }}>
                <div style={{ fontSize: '2.5rem', fontWeight: '800', color: 'var(--assco-orange)' }}>24/7</div>
                <div style={{ fontWeight: '600', color: 'rgba(255, 255, 255, 0.8)' }}>
                  {language === 'fr' ? 'Support technique' : 
                   language === 'ar' ? 'الدعم الفني' : 
                   'Technical support'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes blob-animation-reverse {
          0% {
            transform: translate(0%, 0%) rotate(0deg);
          }
          25% {
            transform: translate(-5%, -5%) rotate(-90deg);
          }
          50% {
            transform: translate(0%, -10%) rotate(-180deg);
          }
          75% {
            transform: translate(5%, -5%) rotate(-270deg);
          }
          100% {
            transform: translate(0%, 0%) rotate(-360deg);
          }
        }
        
        @media (max-width: 768px) {
          div[style*="gridTemplateColumns: repeat(auto-fill, minmax(350px, 1fr))"] {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};

export default WhyChooseUsSection;
